import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';
import { memo } from 'react';

import { tradeSymbolBunja } from '../../symbol';
import { SymbolRightPerpetual } from './perpetual';
import { SymbolRightSpot } from './spot';

const symbolRightBunja = bunja(() => {
  const { isSpotAtom, isFuturesAtom } = bunja.use(tradeSymbolBunja);

  type SymbolType = 'perpetual' | 'spot' | 'unknown';
  const symbolTypeAtom = atom<SymbolType>((get) => {
    const isFutures = get(isFuturesAtom);
    const isSpot = get(isSpotAtom);
    if (isFutures) return 'perpetual';
    if (isSpot) return 'spot';
    return 'unknown';
  });

  return { symbolTypeAtom };
});
symbolRightBunja.debugLabel = 'symbolRightBunja';

export const SymbolRight = memo(() => {
  const { symbolTypeAtom } = useBunja(symbolRightBunja);
  const symbolType = useAtomValue(symbolTypeAtom);
  if (symbolType === 'perpetual') return <SymbolRightPerpetual />;
  if (symbolType === 'spot') return <SymbolRightSpot />;
  return null;
});
